import { gql } from "@apollo/client";

import { EventDefinition } from "Types/EventDefinition";

export type GetEventsReceivedQueryResponse = {
    getEventsReceived: EventDefinition[];
};

export const getEventsReceived = gql`
    query GetEventsReceived($eventType: String!) {
        getEventsReceived(eventType: $eventType) {
            eventType
            eventName
            displayName
            displayEmoji
            displayColor
            showInFeed
            attributes {
                attributeKey
                displayName
            }
            teams {
                id
            }
            updatedBy
            updatedAt
        }
    }
`;
